import { getExportCallLogs } from '@/services/call-log-service/call-log-service';
import { CallLogFilters, CallLogParams } from '@/services/call-log-service/call-log-service.types';
import { useState } from 'react';

interface UseExportCallLogsProps {
  filtersParams: CallLogFilters;
  paginationParams: CallLogParams;
}
export const useExportCallLogs = ({ filtersParams, paginationParams }: UseExportCallLogsProps) => {
  const [isPending, setIsPending] = useState(false);

  const exportCallLogs = async () => {
    setIsPending(true);
    try {
      return await getExportCallLogs({ ...filtersParams, ...paginationParams });
    } finally {
      // Must be `finally`: the request rejects on a 4xx (the API refuses a window
      // that is too wide, inverted, or unparseable) and the spinner would latch on
      // with no way back short of a reload. The rejection still reaches the caller.
      setIsPending(false);
    }
  };

  return { exportCallLogs, isPending };
};
